<div class="d-flex flex-column alig-items-center">
  <div class="login-form mx-auto">
    <form
      #setPassForm="ngForm"
      (ngSubmit)="setPass(setPassForm)"
      novalidate
    >
      <h3>{{'message.toSetYourPassword' | translate}}:</h3>
      <div
        class="mb-3"
        [podValidationClass]="newPassword"
      >
        <label
          for="newPassword"
          class="form-label"
        >{{'label.newPassword' | translate}}</label>
        <input
          type="password"
          class="form-control"
          id="newPassword"
          name="newPassword"
          [(ngModel)]="model.password"
          #newPassword="ngModel"
          validateEqual="repeatnewPassword"
          reverse="true"
          required
          minlength="14"
          password-complexity
          not-repeated-character
        />
        <pod-validation-messages
          [model]="newPassword"
          fieldName="{{'label.newPassword' | translate}}"
        ></pod-validation-messages>
      </div>
      <div
        class="mb-3"
        [podValidationClass]="repeatnewPassword"
      >
        <label
          for="repeatnewPassword"
          class="form-label"
        >{{'label.confirmPassword' | translate}}</label>
        <input
          type="password"
          class="form-control"
          id="repeatnewPassword"
          name="repeatnewPassword"
          [(ngModel)]="model.repeatnewPassword"
          #repeatnewPassword="ngModel"
          validateEqual="newPassword"
          required
        />
        <pod-validation-messages
          [model]="repeatnewPassword"
          fieldName="{{'label.confirmPassword' | translate}}"
        ></pod-validation-messages>
      </div>
      <div class="mb-3">
        <label
          for="captcha"
          class="form-label"
        >Captcha</label>
        <p class="form-text">{{'text.messageCaptcha' | translate}}</p>
        <re-captcha
          size="normal"
          [(ngModel)]="model.captcha"
          id="captcha"
          name="captcha"
          #captcha="ngModel"
          [siteKey]="loginCustomization.siteKey || environment.recaptchaSiteKey"
          badge="inline"
          theme="light"
          [tabindex]="0"
          required
        ></re-captcha>
        <pod-validation-messages
          [model]="captcha"
          fieldName="{{'label.captcha' | translate}}"
        ></pod-validation-messages>
      </div>
      <div class="d-grid gap-3">
        <button
          type="submit"
          class="btn btn-tertiary"
          [disabled]="submitting"
          id="recovery-password-submit"
        >
          {{ (submitting ? 'label.saving...' : 'label.setPassword') | translate}}
        </button>
        <a
          class="btn btn-secondary"
          routerLink="/login"
          id="recovery-password-cancel"
        >{{'label.cancel' | translate}}</a>
      </div>
    </form>
  </div>
</div>